import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

import { useUploadFile } from "../api/upload-file";

type UploadInputProps = {
  isSubmitting: boolean;
  onChange: (fileName: { id: string; url: string }) => void;
  value: {
    id: string;
    url: string;
  };
};

export default function UploadInput(props: UploadInputProps) {
  const { t } = useTranslation();
  const { onChange, isSubmitting, value } = props;
  const {
    mutateAsync: uploadFile,
    data: uploadedFile,
    isSuccess,
    isPending: isUploading,
    reset,
  } = useUploadFile();

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files[0]) {
      const file = files[0];
      const formData = new FormData();
      formData.append("file", file);

      const response = await uploadFile({
        formData: {
          type: "IMG",
          file,
        },
      });

      if (response) {
        onChange({ id: response.id, url: response.file_name });
      }
    }
  };

  if (isSuccess) {
    return (
      <div>
        <img
          src={`${import.meta.env.VITE_BUCKET}/${uploadedFile.file_name}`}
          alt={uploadedFile.file_name}
          className="h-16 rounded border p-1"
        />

        <Button
          size="sm"
          variant="outline"
          className="mt-2"
          type="button"
          onClick={() => {
            reset();
            onChange({ id: "", url: "" });
          }}
        >
          {t("upload.removeFile")}
        </Button>
      </div>
    );
  }

  if (value.id) {
    return (
      <div>
        <img
          src={`${import.meta.env.VITE_BUCKET}/${value.url}`}
          alt={value.url}
          className="h-16 rounded border p-1"
        />

        <Button
          size="sm"
          variant="outline"
          className="mt-2"
          type="button"
          onClick={() => {
            reset();
            onChange({ id: "", url: "" });
          }}
        >
          {t("upload.removeFile")}
        </Button>
      </div>
    );
  }

  return (
    <div className="relative">
      <Input
        className="h-8 px-2 py-1"
        disabled={isSubmitting || isUploading}
        type="file"
        onChange={handleFileChange}
      />
      {isUploading && (
        <Loader2 className="absolute right-2 top-[5px] size-6 animate-spin text-primary" />
      )}
    </div>
  );
}
